const TeamTabContentStyles = {
  teamTabContentWrapper: {
    "& p":{
      fontSize: "12px",  
    },
  },
  designationName:{
    fontSize: "12px",
  },
  chips: {
    background: "red",
  },
  editBtn:{
    fontSize: "12px",
    fontWeight: "700",
    color: "blue",
  },
  tableScrooData :{
    maxHeight: "calc(100vh - 225px)",
      overflowY: "auto"
  }
};

export default TeamTabContentStyles;
